import { GuestSpeakerStreamState } from '@player/features/guestSpeaker/model/state';
import { GUEST_SPEAKER_SLICE_KEY } from './slice';
/**
 *
 */
export function streamStateSelector(state) {
    return state[GUEST_SPEAKER_SLICE_KEY].streamState;
}
/**
 *
 */
export function cameraEnabledSelector(state) {
    return state[GUEST_SPEAKER_SLICE_KEY].streamControls.cameraEnabled;
}
/**
 *
 */
export function microphoneMutedSelector(state) {
    return state[GUEST_SPEAKER_SLICE_KEY].streamControls.microphoneMuted;
}
/**
 *
 */
export function guestSpeakerActionsSelector(state) {
    return state[GUEST_SPEAKER_SLICE_KEY].actions;
}
/**
 *
 */
export function isReadyOrStreamingSelector(state) {
    return (state[GUEST_SPEAKER_SLICE_KEY].streamState ===
        GuestSpeakerStreamState.READY_TO_STREAM ||
        state[GUEST_SPEAKER_SLICE_KEY].streamState ===
            GuestSpeakerStreamState.STREAMING);
}
/**
 *
 */
export function hostTokenSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state[GUEST_SPEAKER_SLICE_KEY].hostTokens[liveStreamId];
}
